export const variables = {
    tableRowsCount: 12,
    borderColor: "#90e5fc",
    borderBottomColor: "#d4002a",
    headerColor: "#84817d",
    stripedColor: "#faf9f9",
    textColor: "#d4002a",
  };